import { Expose } from "class-transformer";

export class CreateProjectHasOrderDto {
  @Expose()
  projectId: string;

  @Expose()
  orderId: string;
}
